var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"today-alarm"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"guanBoxNew"},[_vm._v("暂无数据")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.show),expression:"!show"}],staticClass:"guanBox",attrs:{"id":_vm.echartId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }